import { createSlice } from '@reduxjs/toolkit'

export const sidSlice = createSlice({
  name: 'sid',
  initialState: {
    isSettled: false,
    sid: '',
    initSIDToAgents: false,
  },
  reducers: {
    sidSettled: (state, action) => {
      state.sid = action.payload
      state.isSettled = true
    },
    initSIDToAgents: (state, action) => {
      state.initSIDToAgents = true
    },
  },
})

export const selectSIDInfo = (state) => state.sid

export const { sidSettled, initSIDToAgents } = sidSlice.actions

export default sidSlice.reducer
